import React, { useEffect, useState } from 'react';

// COMPONENTS
import Icon from '../Icon/Icon';

// ASSETS
import { Checkmark } from './assets/Checkmark';

// ENUMS
import { InputMode } from '../../enums/inputMode';
import { InputType } from '../../enums/inputType';
import { Icons } from '../../enums/icons';

// INTERFACES
import { IInput } from '../../interfaces/Input.interface';

// STYLES
import {
  CheckMarkContainer,
  Container,
  Error,
  InputContainer,
  Label,
  LabelContainer,
  StyledInput,
  SubLabelText,
  PasswordContainer,
  OptionalLabel
} from './styles';

const Input: React.FC<IInput> = ({
  haserror,
  isDisabled,
  label,
  name,
  onBlur,
  onChange,
  onKeyUp,
  subLabel,
  externalError,
  hasCheckmark = false,
  type = InputType.TEXT,
  value,
  error = {},
  width,
  isfocused,
  min,
  max,
  inputModeProp = InputMode.TEXT,
  isPassword,
  optionalLabel,
  ...rest
}: IInput) => {
  const [typeState, setTypeState] = useState<InputType>(InputType.TEXT);
  const handleType = () => {
    if (type == InputType.PASSWORD && typeState == InputType.PASSWORD) {
      setTypeState(InputType.TEXT);
    } else {
      setTypeState(type);
    }
  };

  useEffect(() => {
    setTypeState(type);
  }, []);

  return (
    <Container width={width}>
      <LabelContainer>
        <Label htmlFor={name} haserror={error[name] || externalError} isfocused={isfocused} isDisabled={isDisabled}>
          {label} {!!optionalLabel && <OptionalLabel>{optionalLabel}</OptionalLabel>}
        </Label>

        {!!subLabel && <SubLabelText>{subLabel}</SubLabelText>}
      </LabelContainer>

      <InputContainer>
        {!!error[name] && <Error title={error[name]}>{error[name]}</Error>}
        {!!externalError && <Error title={externalError}>{externalError}</Error>}
        <StyledInput
          autoComplete="nope"
          onBlur={onBlur}
          onChange={onChange}
          name={name}
          type={typeState}
          disabled={isDisabled}
          haserror={error[name] || externalError}
          isfocused={isfocused}
          value={value}
          min={min}
          max={max}
          inputMode={inputModeProp}
          onKeyUp={onKeyUp}
          {...rest}
        />
      </InputContainer>

      {hasCheckmark && !!value && !isfocused && !!!error[name] && (
        <CheckMarkContainer>
          <Checkmark />
        </CheckMarkContainer>
      )}

      {isPassword && (
        <PasswordContainer onClick={handleType}>
          {typeState === InputType.TEXT ? <Icon type={Icons.EYE_OPEN} /> : <Icon type={Icons.EYE_CLOSE} />}
        </PasswordContainer>
      )}
    </Container>
  );
};

export default Input;
